// Need to use the React-specific entry point to import `createApi`
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setCartItems, setCartOffers, setCartSummary } from "./cartSlice";

interface GetCartItemParams {
  couponCode?: string;
  guestUserId: string | null;
  countryCode: string;
}

interface CartResponse {
  cartItems: CartItem[];
  cartSummary: CartSummary;
  offers: CartOffer[];
}

// Define a service using a base URL and expected endpoints
export const cartApiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.NEXT_PUBLIC_BACKEND_URL + "/api",
  }),
  reducerPath: "cartApi",
  tagTypes: ["cart"],
  endpoints: (build) => ({
    getCartItems: build.query<CartResponse, GetCartItemParams>({
      query: (params) => {
        const queryString = new URLSearchParams(
          Object.entries(params).reduce(
            (acc, [key, value]) => {
              if (value !== undefined && value !== null) {
                acc[key] = String(value);
              }
              return acc;
            },
            {} as Record<string, string>
          )
        ).toString();
        return `/get-cart-item?${queryString}`;
      },
      onQueryStarted: async (queryArgument, { queryFulfilled, dispatch }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(setCartItems(data.cartItems));
          dispatch(setCartSummary(data.cartSummary));
          dispatch(setCartOffers(data.offers));
        } catch (error) {
          console.log("error :>> ", error);
        }
      },
      //   providesTags: (result, error, id) => [{ type: "cart", id }],
    }),
  }),
});

// Hooks are auto-generated by RTK-Query
// Same as `cartApiSlice.endpoints.getQuotes.useQuery`
export const { useGetCartItemsQuery } = cartApiSlice;
